<template>
  <div
    class="questions-panel__question questions-panel__final health-check-form"
  >
    <div class="questions-panel__question__inner" v-if="!success">
      <h2 class="questions-panel__question__section-title">
        {{ hcData.submission_panel_title }}
      </h2>
      <div v-html="hcData.submission_panel_content"></div>
      <div
        v-if="Object.keys(validationErrors).length"
        class="health-check-form__errors"
      >
        <p>Please check you have completed all the required fields</p>
      </div>
      <form class="questions-panel__final__form" @submit.prevent.stop="submit">
        <div class="questions-panel__final__form__fields">
          <fieldset>
            <input
              type="text"
              v-model="hcData.userData.first_name"
              v-bind:placeholder="hcData.input_placeholder_first_name"
              name="given-name"
              v-bind:class="getInputClass('first_name')"
            />
          </fieldset>
          <fieldset>
            <input
              type="text"
              v-model="hcData.userData.last_name"
              v-bind:placeholder="hcData.input_placeholder_last_name"
              name="family-name"
              v-bind:class="getInputClass('last_name')"
            />
          </fieldset>
          <fieldset>
            <input
              type="email"
              v-model="hcData.userData.email"
              v-bind:placeholder="hcData.input_placeholder_email_address"
              name="email"
              v-bind:class="getInputClass('email')"
            />
          </fieldset>
          <fieldset>
            <input
              type="text"
              v-model="hcData.userData.role"
              v-bind:placeholder="hcData.input_placeholder_role"
              name="job-title"
              v-bind:class="getInputClass('role')"
            />
          </fieldset>
          <fieldset>
            <input
              type="text"
              v-model="hcData.userData.organisation"
              v-bind:placeholder="hcData.input_placeholder_organisation"
              name="company-name"
              v-bind:class="getInputClass('organisation')"
            />
          </fieldset>
          <input
            type="hidden"
            v-model="hcData.userData.anti_spam_response"
            autocomplete="off"
          />

          <div class="questions-panel__final__form__recaptcha">
            <div v-if="!recaptchaLoaded" class="recaptcha-loading">
              Loading reCAPTCHA...
            </div>
            <vue-recaptcha
              v-if="recaptchaLoaded"
              :sitekey="recaptchaSiteKey"
              @verify="onRecaptchaVerify"
              @expired="onRecaptchaExpired"
              @error="onRecaptchaError"
              ref="recaptcha"
            ></vue-recaptcha>
            <div v-if="recaptchaError" class="recaptcha-error">
              {{ recaptchaError }}
            </div>
          </div>
        </div>
        
        <div class="questions-panel__final__form__action">
          <button
            class="questions-panel__final__form__action__submit"
            type="submit"
          >
            {{ hcData.submission_panel_submit_button_text }}
          </button>
          <div v-if="error">
            Oh no. There was an error!
            <br />
            <pre>{{ error }}</pre>
          </div>
        </div>
      </form>
    </div>

    <!--        The thank you message-->
    <div class="questions-panel__question__inner" v-else>
      <h2 class="questions-panel__question__section-title">
        {{ hcData.submission_panel_thankyou_title }}
      </h2>
      <div v-html="hcData.submission_panel_thankyou_content"></div>
    </div>

    <div class="health-check-form__progress-bar">
      <ProgressBar />
    </div>
  </div>
</template>

<script>
import store from "../store";
import axios from "axios";
import ProgressBar from "./ProgressBar";

export default {
  components: { ProgressBar },
  store: store,
  data: function() {
    return {
      response: null,
      error: null,
      success: null,
      validationErrors: {},
      recaptchaResponse: null,
      recaptchaError: null,
      recaptchaLoaded: false,
      recaptchaSiteKey:
        process.env.VUE_APP_RECAPTCHA_SITE_KEY ||
        "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" // Default test key
    };
  },
  name: "Form",
  methods: {
    /**
     * Submit the form
     */
    submit() {
      if (this.checkForm()) {
        var that = this;
        // Add reCAPTCHA response to form data
        const formData = {
          data: this.hcData,
          recaptcha_response: this.recaptchaResponse
        };

        axios
          .post(this.apiEndpointUrl, formData)
          .then(function(response) {
            that.success = true;
            that.response = response;
            // Reset reCAPTCHA after successful submission
            that.$refs.recaptcha.reset();
          })
          .catch(function(error) {
            that.error = error;
            // Reset reCAPTCHA after failed submission
            that.$refs.recaptcha.reset();
            that.recaptchaResponse = null;
          });
      }
    },
    checkForm() {
      this.validationErrors = {};
      this.recaptchaError = null;

      if (!this.hcData.userData.first_name) {
        this.validationErrors.first_name = "Please enter your first name";
      }
      if (!this.hcData.userData.last_name) {
        this.validationErrors.last_name = "Please enter your last name";
      }
      if (!this.hcData.userData.email) {
        this.validationErrors.email = "Please enter your email address";
      }
      if (!this.hcData.userData.role) {
        this.validationErrors.role = "Please enter your position/role";
      }
      if (!this.hcData.userData.organisation) {
        this.validationErrors.organisation =
          "Please enter your organisation name";
      }
      if (!this.recaptchaLoaded) {
        this.recaptchaError = "reCAPTCHA is loading, please wait...";
      } else if (!this.recaptchaResponse) {
        this.recaptchaError = "Please complete the reCAPTCHA verification";
      }

      if (
        Object.keys(this.validationErrors).length === 0 &&
        !this.recaptchaError
      ) {
        return true;
      } else {
        return false;
      }
    },
    getInputClass(propertyName) {
      // return this.validationErrors[propertyName];
      if (this.validationErrors[propertyName]) {
        return "error";
      } else {
        return "";
      }
    },
    /**
     * Handle reCAPTCHA verification
     */
    onRecaptchaVerify(response) {
      this.recaptchaResponse = response;
      this.recaptchaError = null;
    },
    /**
     * Handle reCAPTCHA expiration
     */
    onRecaptchaExpired() {
      this.recaptchaResponse = null;
      this.recaptchaError = "reCAPTCHA has expired. Please verify again.";
      this.$refs.recaptcha.reset();
    },
    /**
     * Handle reCAPTCHA error
     */
    onRecaptchaError(error) {
      this.recaptchaResponse = null;
      // Only show error message for actual loading failures, not network errors
      if (error && error.toString().includes("network")) {
        this.recaptchaError =
          "reCAPTCHA failed to load. Please refresh the page.";
      }
    },
    /**
     * Check if reCAPTCHA API is loaded
     */
    checkRecaptchaLoaded() {
      if (window.grecaptcha && window.grecaptcha.render) {
        this.recaptchaLoaded = true;
        this.recaptchaError = null; // Clear any loading errors
      } else {
        // Check again after a short delay
        setTimeout(() => this.checkRecaptchaLoaded(), 100);
      }
    }
  },
  mounted() {
    // Check if reCAPTCHA is already loaded
    this.checkRecaptchaLoaded();

    // Set up a global callback for when reCAPTCHA loads
    window.vueRecaptchaApiLoaded = () => {
      this.recaptchaLoaded = true;
    };
  },
  computed: {
    hcData() {
      return store.getters.hcData;
    },
    apiEndpointUrl() {
      return store.getters.apiEndpointUrl;
    },
    totalSections() {
      return store.getters.hcData.sections.length;
    }
  }
};
</script>

<style lang="scss">
.health-check-form {
  position: relative;

  &__errors {
    color: #ff0100;
    margin: 20px 0 0;

    ul {
      margin: 10px 0 0 0;
      padding: 0 0 0 18px;

      li {
        margin: 0 0 5px 0;
      }
    }
  }

  &__progress-bar {
    @media (max-width: 767px) {
      position: absolute;
      background-color: #0000ff;
      height: 30px;
      left: -30px;
      padding: 0 30px;
      width: 100vw;
      z-index: 10;
      margin-top: -30px;
    }

    .progress-bar {
      bottom: initial;
      margin-top: 20px;

      @media (max-width: 767px) {
        opacity: 1;
        top: 0 !important;
        position: relative;
        margin-top: 0;
        color: #ffffff !important;
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: center;
      }

      &__bar {
        border-color: rgba(255, 255, 255, 0.75);
        &__progress {
          background-color: rgba(255, 255, 255, 0.75);
        }
      }
    }
  }

  .questions-panel__question__inner {
    @media (max-width: 767px) {
      padding: {
        left: 44px !important;
        right: 44px !important;
        bottom: 60px !important;
      }
    }
  }

  .questions-panel__question__section-title {
    @media (max-width: 767px) {
      text-align: center;
      flex-direction: column;
    }
  }
}
</style>
